import { lazy } from "react";
import Loadable from "app/components/Loadable";

const MobileAppUpdatePage = Loadable(lazy(() => import("./MobileAppUpdatePage")));

const MobileAppUpdateRoutes = [
  {
    path: "/admin/mobile-app-update",
    element: <MobileAppUpdatePage />,
  },
];

export default MobileAppUpdateRoutes;
